import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageCreateReportPage } from './message-create-report';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		MessageCreateReportPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageCreateReportPage),
	],
})
export class MessageCreateReportPageModule {}



// WEBPACK FOOTER //
// ./src/pages/message-create-report/message-create-report.module.ts